<template>
    <div>
        <div v-if="cTransportation">
            <p v-if="cContCategory || cVehicleCategoryName">
                {{ cTransportation === 'CONTAINER' ? cContCategory + ' feet' : cVehicleCategoryName }}
            </p>
            <p>
                Sản lượng: {{ $formatters.formatCurrency(cProductivityOrder) }}
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const { $formatters } = useNuxtApp()

const cTransportation = computed(() => params?.value?.data?.transportation)
const cContCategory = computed(() => params?.value?.data?.contCategory)
const cProductivityOrder = computed(() => params?.value?.data?.productivityOrder)
const cVehicleCategoryName = computed(() => params?.value?.data?.vehicleCategoryName)
</script>
